import { requestBuilder } from '../../http/RequestBuilder';

export enum AcatTestScenario {
    INCOMING_FULL_TRANSFER = 'INCFULLTRANSFER',
    INCOMING_PARTIAL_TRANSFER = 'INCPARTIALTRANSFER',
    INCOMING_FULL_EQTY_CASH_MF = 'INCFULLEQTYCASHMF',
    INCOMING_FULL_EQTY_CASH_MF_FI = 'INCFULLEQTYCASHMFFI',
    INCOMING_PTR_EQTY_CASH_MF = 'INCPTREQTYCASHMF',
    INCOMING_PTR_EQTY_CASH_MF_FI = 'INCPTREQTYCASHMFFI',
    RECEIVER_IN_FULL_REJECT = 'RECEIVERINFULLREJECT',
    DELIVER_INC_FULL_REJECT = 'DELIVERINCFULLREJECT',
    INCOMING_FULL_CASH_ONLY = 'INCFULLCASHONLY',
    INCOMING_FULL_EQTY_ONLY = 'INCFULLEQTYONLY',
}

export interface SimulateAcatRequest {
    apexAccountId: string;
    scenario: AcatTestScenario;
    comment?: string;
}

export interface SimulateAcatTransferDetails {
    name: string;
    acatControlNumber?: string;
    state?: string;
    direction?: string;
    transferType?: string;
    createTime?: string;
}

export interface SimulateAcatResponse {
    success: boolean;
    message: string;
    transfer?: SimulateAcatTransferDetails;
    error?: string;
}

const useSimulateAcat = requestBuilder.mutation<
    SimulateAcatResponse,
    SimulateAcatRequest
>({
    endpoint: '/api/acat-simulations/create',
    method: 'POST',
});

export default useSimulateAcat;
